import { axios } from '@Root/API'

export const remove = (studyProgrammeId, sessionStatusId ) => {
	return axios.delete(`course-session/${studyProgrammeId}/session-status/${sessionStatusId}`)
}
